
import React from 'react'

interface Props {
  title: string
  subtitle?: string
}

const ContentHeaderTitle = ({ title, subtitle }: Props) => {

  return (
    <div className="ul-widget__head-label flex-grow-1">
      <h3 className="ul-widget__head-title">
        {title}
      </h3>
      {subtitle && (
        <div className="ul-widget__head-subtitle">
          {subtitle}
        </div>
      )}
    </div>
  )
}

export default ContentHeaderTitle
